import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { RootStateType } from 'store'
import * as API from 'api/finishdelivery'

export type FinishdeliveryState = {
  status: 'idle' | 'loading' | 'failed' | 'success'
}

const initialState: FinishdeliveryState = {
  status: 'idle',
}

type PostType = {
  sessionId: string
  message: string
}
export const finishdelivery = createAsyncThunk(
  'finishdelivery/finishdelivery',
  async ({ sessionId, message }: PostType) => {
    return await API.finishdelivery(sessionId, message)
  }
)

export const finishdeliverySlice = createSlice({
  name: 'finishdelivery',
  initialState,
  reducers: {
    clearStatus: state => {
      state.status = 'idle'
    },
  },
  extraReducers: builder => {
    builder
      .addCase(finishdelivery.pending, state => {
        state.status = 'loading'
      })
      .addCase(finishdelivery.fulfilled, state => {
        state.status = 'success'
      })
      .addCase(finishdelivery.rejected, state => {
        state.status = 'failed'
      })
  },
})

export const { clearStatus } = finishdeliverySlice.actions

export const selectFinishdelivery = (state: RootStateType) => ({ ...state.finishdelivery })

export default finishdeliverySlice.reducer
